export default __webpack_public_path__ + "static/media/shoppingcart.b6da40a3.png";